// extracted by mini-css-extract-plugin
module.exports = {"rootBackgroundWrapper":"FooterBackgroundWrapper_rootBackgroundWrapper__943sV","rootTopOffset":"FooterBackgroundWrapper_rootTopOffset__H5R7N"};